module.exports = __webpack_public_path__ + "static/ftb-mag-9e1e73c4719ee5e7e9301cbedb5561a9.png";